import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  encryptAES(value:any){
    const encrypted = CryptoJS.AES.encrypt(value, '').toString();
    return encrypted
  }
  decryptAES(encryptedValue:any){
    const decrypted = CryptoJS.AES.decrypt(encryptedValue, '').toString(CryptoJS.enc.Utf8);
    return decrypted
  }
}
